import { Link } from "react-router-dom";

export default function ProjectThumbnail({ project }) {
    const projectData = project?.attributes;

    const thumbnailData = projectData.thumbnail?.data?.attributes;
    const aspectRatio = thumbnailData?.width / thumbnailData?.height;

    let thumbnailUrl = thumbnailData?.formats?.thumbnail?.url;

    if (aspectRatio && aspectRatio < 1) {
        thumbnailUrl = thumbnailData?.formats?.small?.url;
    }

    if (!thumbnailUrl) {
        thumbnailUrl = thumbnailData?.url;
    }

    return (
        <div style={{ width: "100%" }}>
            <a href={`/projects/${project.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                <div style={{
                    width: "100%",
                    aspectRatio: 16 / 9,
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: 4,
                }}>
                    <img style={{ width: "100%", aspectRatio: 16 / 9, objectFit: "cover" }} src={thumbnailUrl} alt="Project thumbnail" loading="lazy" />
                    {projectData.state === "concept" &&
                        <div title="Koncept" style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "40px",
                            height: "40px",
                            background: "yellow",
                            clipPath: "polygon(0 0, 100% 0, 100% 100%)"
                        }}></div>
                    }
                </div>
                {/* <p>{projectData.rating}</p> */}
                <h3 style={{
                    margin: "10px 0 10px 0",
                    // minHeight: "48px"
                }}>{projectData.name}</h3>
                <p style={{ color: "var(--cd-green)", fontSize: 16, margin: "10px 0 0 0" }}>{projectData.clientName}</p>
                <p style={{ fontSize: 14, margin: "1px 0" }}>Typ: {projectData.services.data.map(service => service.attributes?.name).join(", ")}</p>
                <p style={{ fontSize: 14, margin: "1px 0" }}>Rok realizace: {projectData.year}</p>
            </a>
        </div>
    );
}
